<template>
  <div id="app">
    <header class="site-header">
      <div class="announcement-bar">
        <div class="container announcement-content">
          <span>Cross-Border Direct Sourcing · Best Sellers · Dedicated Consultant Real-Time Follow-up</span>
          <router-link to="/contact" class="announcement-link">
            Book Product Consultant
          </router-link>
        </div>
      </div>

      <nav class="main-nav" :class="{ 'is-scrolled': isScrolled, 'is-open': mobileNavOpen }">
        <div class="container nav-content">
<!--          <router-link to="/" class="logo" @click="closeMobileNav">-->
<!--            <img src="/logo.png" alt="Yuanchuangde Technology" />-->
<!--          </router-link>-->

          <div class="nav-links">
            <router-link to="/" @click="closeMobileNav">Home</router-link>
            <button type="button" @click="navigateToSection('new-arrivals')">New Arrivals</button>
            <button type="button" @click="navigateToSection('best-selling')">Best Sellers</button>
            <router-link to="/products" @click="closeMobileNav">Products</router-link>
            <router-link to="/about" @click="closeMobileNav">About</router-link>
            <router-link to="/contact" @click="closeMobileNav">Support</router-link>
            <router-link to="/payment" @click="closeMobileNav">Payment Guide</router-link>
          </div>

          <div class="nav-actions">
            <router-link to="/cart" class="nav-cart" @click="closeMobileNav">
              <span class="cart-icon">🛒</span>
              <div class="cart-info">
                <span class="label">Cart</span>
                <span class="meta">{{ cartSummary.items }} items · ${{ cartSummary.total }}</span>
              </div>
            </router-link>
          </div>

          <button class="mobile-toggle" type="button" @click="mobileNavOpen = !mobileNavOpen">
            <span v-if="!mobileNavOpen">Menu</span>
            <span v-else>Close</span>
          </button>
        </div>
        <div class="mobile-panel" v-if="mobileNavOpen">
          <div class="mobile-links">
            <router-link to="/" @click="closeMobileNav">Home</router-link>
            <button type="button" @click="navigateToSection('new-arrivals')">New Arrivals</button>
            <button type="button" @click="navigateToSection('best-selling')">Best Sellers</button>
            <router-link to="/products" @click="closeMobileNav">Products</router-link>
            <router-link to="/about" @click="closeMobileNav">About</router-link>
            <router-link to="/contact" @click="closeMobileNav">Support</router-link>
            <router-link to="/payment" @click="closeMobileNav">Payment Guide</router-link>
            <router-link to="/cart" @click="closeMobileNav">Cart</router-link>
          </div>
          <div class="mobile-actions">
            <router-link to="/cart" class="mobile-cart" @click="closeMobileNav">
              <span>Cart</span>
              <span>{{ cartSummary.items }} items · ${{ cartSummary.total }}</span>
            </router-link>
          </div>
        </div>
      </nav>
    </header>

    <main class="app-main">
      <router-view />
    </main>

    <footer class="site-footer">
      <div class="container footer-grid">
        <div class="footer-brand">
          <div class="footer-contact">
            <div class="contact-item">
              <span class="label">Email</span>
              <a :href="`mailto:${companyInfo.email}`">{{ companyInfo.email || 'info@ycdit.com' }}</a>
            </div>
            <div class="contact-item">
              <span class="label">Phone</span>
              <a>{{ companyInfo.phone || '+86 755 8888 6666' }}</a>
            </div>
            <div class="contact-item">
              <span class="label">Address</span>
              <p>{{ companyInfo.address || 'Building X, Industrial Park, Longhua District, Shenzhen' }}</p>
            </div>
          </div>
        </div>

        <div class="footer-column">
          <h3>Product Series</h3>
          <button type="button" @click="navigateToSection('category-highlight')">Featured New</button>
          <button type="button" @click="navigateToSection('best-selling')">Best Sellers</button>
          <button type="button" @click="navigateToSection('collections')">Bundle Sets</button>
          <router-link to="/products">All Products</router-link>
        </div>

        <div class="footer-column">
          <h3>Service Support</h3>
          <router-link to="/contact">Contact Support</router-link>
          <router-link to="/payment">Payment & Logistics</router-link>
          <router-link to="/about">Brand & Certifications</router-link>
          <a href="#" @click.prevent="navigateToSection('faq')">FAQ</a>
        </div>

        <div class="footer-column">
          <h3>Latest Updates</h3>
          <p>Subscribe to get new product releases, promotions and industry news.</p>
          <form class="footer-subscribe" @submit.prevent>
            <input type="email" placeholder="Enter your email" required />
            <button type="submit">Subscribe</button>
          </form>
          <div class="footer-social">
            <a href="#" aria-label="Facebook">Facebook</a>
            <a href="#" aria-label="YouTube">YouTube</a>
            <a href="#" aria-label="LinkedIn">LinkedIn</a>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="container footer-bottom-content">
          <p>&copy; 2025 Shenzhen Yuanchuangde Technology Co., Ltd. All Rights Reserved.</p>
          <div class="footer-links">
            <router-link to="/about">Company Info</router-link>
            <router-link to="/contact">Contact Us</router-link>
            <router-link to="/payment">Payment & Logistics</router-link>
            <a href="#">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      companyInfo: {
        address: '',
        phone: '',
        email: ''
      },
      mobileNavOpen: false,
      isScrolled: false,
      cartItems: [] // Shopping cart items list
    }
  },
  computed: {
    cartSummary() {
      const items = this.cartItems.reduce((sum, item) => sum + item.quantity, 0)
      const total = this.cartItems.reduce((sum, item) => {
        const price = parseFloat(item.prodPrice) || 0
        return sum + price * item.quantity
      }, 0)
      return {
        items,
        total: total.toFixed(2)
      }
    }
  },
  provide() {
    return {
      addToCart: this.addToCart,
      removeFromCart: this.removeFromCart,
      updateCartQuantity: this.updateCartQuantity,
      getCartItems: () => this.cartItems,
      clearCart: this.clearCart
    }
  },
  mounted() {
    this.fetchCompanyInfo()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    // Load cart data from localStorage
    this.loadCartFromStorage()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    $route() {
      this.mobileNavOpen = false
    }
  },
  methods: {
    fetchCompanyInfo() {
      this.$axios.post('/asin/company').then(response => {
        if (response.data.code === 0) {
          this.companyInfo = response.data.data
        } else {
          throw new Error(response.data.message || 'Failed to fetch company information')
        }
      }).catch(error => {
        console.error('Error fetching company information:', error)
      })
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 20
    },
    closeMobileNav() {
      this.mobileNavOpen = false
    },
    navigateToSection(sectionId) {
      const executeScroll = () => {
        this.$nextTick(() => {
          const anchor = document.getElementById(sectionId)
          if (anchor) {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }
        })
      }

      if (this.$route.path !== '/') {
        this.$router.push({ path: '/', hash: `#${sectionId}` }).then(() => {
          executeScroll()
        })
      } else {
        executeScroll()
      }
      this.mobileNavOpen = false
    },
    // Add to cart
    addToCart(product) {
      if (!product || !product.prodId) return

      const existingItem = this.cartItems.find(item => item.prodId === product.prodId)

      if (existingItem) {
        existingItem.quantity += 1
      } else {
        this.cartItems.push({
          ...product,
          quantity: 1
        })
      }

      this.saveCartToStorage()
    },
    // Remove from cart
    removeFromCart(prodId) {
      const index = this.cartItems.findIndex(item => item.prodId === prodId)
      if (index > -1) {
        this.cartItems.splice(index, 1)
        this.saveCartToStorage()
      }
    },
    // Update cart item quantity
    updateCartQuantity(prodId, quantity) {
      const item = this.cartItems.find(item => item.prodId === prodId)
      if (item) {
        if (quantity <= 0) {
          this.removeFromCart(prodId)
        } else {
          item.quantity = quantity
          this.saveCartToStorage()
        }
      }
    },
    // Clear cart
    clearCart() {
      this.cartItems = []
      this.saveCartToStorage()
    },
    // Save cart to localStorage
    saveCartToStorage() {
      try {
        localStorage.setItem('cartItems', JSON.stringify(this.cartItems))
      } catch (error) {
        console.error('Failed to save cart to storage:', error)
      }
    },
    // Load cart from localStorage
    loadCartFromStorage() {
      try {
        const saved = localStorage.getItem('cartItems')
        if (saved) {
          this.cartItems = JSON.parse(saved)
        }
      } catch (error) {
        console.error('Failed to load cart from storage:', error)
      }
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-light);
}

.app-main {
  flex: 1;
  margin-top: 0;
}

.site-header {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.announcement-bar {
  background: var(--brand-primary);
  color: #fff;
  font-size: 0.95rem;
}

.announcement-content {
  padding: 10px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.announcement-link {
  color: #fff;
  font-weight: 600;
  text-decoration: underline;
  transition: var(--transition-base);
  white-space: nowrap;
}

.announcement-link:hover {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
}

.main-nav {
  background: rgba(255, 255, 255, 0.98);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  transition: var(--transition-base);
}

.main-nav.is-scrolled {
  box-shadow: var(--shadow-sm);
}

.nav-content {
  padding: 18px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
}

.logo img {
  height: 48px;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 18px;
}

.nav-links a,
.nav-links button {
  border: none;
  background: transparent;
  font-size: 0.98rem;
  font-weight: 600;
  color: var(--text-primary);
  padding: 10px 12px;
  border-radius: 999px;
  cursor: pointer;
  transition: var(--transition-base);
}

.nav-links a:hover,
.nav-links button:hover,
.nav-links a.router-link-active {
  color: var(--brand-accent);
  background: rgba(0, 113, 227, 0.08);
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.nav-cart {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  border-radius: 10px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid rgba(0, 113, 227, 0.12);
  color: var(--brand-primary);
  font-weight: 600;
  transition: var(--transition-base);
  text-decoration: none;
  position: relative;
}

.nav-cart:hover {
  background: linear-gradient(135deg, #e3f2ff 0%, #dbeafe 100%);
  border-color: rgba(0, 113, 227, 0.2);
  box-shadow: 0 4px 12px rgba(0, 113, 227, 0.15);
  transform: translateY(-2px);
}

.cart-icon {
  font-size: 1.4rem;
  line-height: 1;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

.cart-info {
  display: flex;
  flex-direction: column;
  line-height: 1.4;
  gap: 2px;
}

.cart-info .label {
  font-weight: 700;
  color: var(--brand-primary);
  font-size: 0.95rem;
  letter-spacing: 0.01em;
}

.cart-info .meta {
  color: #64748b;
  font-weight: 600;
  font-size: 0.85rem;
}

.contact-btn {
  padding: 12px 24px;
  font-size: 0.95rem;
  white-space: nowrap;
  background: linear-gradient(135deg, #0071e3 0%, #005bb5 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(0, 113, 227, 0.2);
}

.contact-btn:hover {
  background: linear-gradient(135deg, #005bb5 0%, #004a94 100%);
  box-shadow: 0 4px 12px rgba(0, 113, 227, 0.3);
  transform: translateY(-1px);
}

.mobile-toggle {
  display: none;
  border: none;
  background: rgba(15, 23, 42, 0.08);
  padding: 8px 16px;
  border-radius: 999px;
  font-weight: 600;
}

.mobile-panel {
  display: none;
}

.site-footer {
  background: var(--brand-primary);
  color: rgba(255, 255, 255, 0.85);
  padding: 64px 0 0;
  margin-top: 80px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 48px;
  align-items: start;
}

.footer-brand img {
  height: 52px;
  margin-bottom: 18px;
}

.footer-brand p {
  margin-bottom: 18px;
  line-height: 1.7;
}

.footer-contact {
  display: grid;
  gap: 12px;
}

.contact-item .label {
  display: block;
  font-size: 0.8rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.48);
  margin-bottom: 4px;
}

.footer-column h3 {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 16px;
  color: #fff;
}

.footer-column a,
.footer-column button {
  display: block;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 10px;
  background: transparent;
  border: none;
  padding: 0;
  font-size: 0.95rem;
  text-align: left;
  cursor: pointer;
}

.footer-column a:hover,
.footer-column button:hover {
  color: #fff;
}

.footer-subscribe {
  margin-top: 16px;
  display: flex;
  gap: 10px;
  max-width: 360px;
}

.footer-subscribe input {
  flex: 1;
  height: 44px;
  padding: 0 16px;
  border-radius: 12px;
  border: none;
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
}

.footer-subscribe button {
  height: 44px;
  padding: 0 18px;
  border-radius: 12px;
  border: none;
  background: #fff;
  color: var(--brand-primary);
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.footer-social {
  margin-top: 18px;
  display: flex;
  gap: 18px;
}

.footer-bottom {
  margin-top: 48px;
  padding: 24px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  font-size: 0.9rem;
}

.footer-links {
  display: flex;
  gap: 20px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
}

.footer-links a:hover {
  color: #fff;
}

@media (max-width: 1024px) {
  .app-main {
    margin-top: 0;
  }

  .nav-links {
    display: none;
  }

  .nav-actions {
    display: none;
  }

  .mobile-toggle {
    display: inline-flex;
  }

  .main-nav.is-open .mobile-panel {
    display: block;
    background: #fff;
    border-top: 1px solid rgba(15, 23, 42, 0.06);
  }

  .mobile-links,
  .mobile-actions {
    display: grid;
    gap: 16px;
    padding: 18px 24px;
  }

  .mobile-links button,
  .mobile-links a {
    text-align: left;
    padding: 12px 0;
    border-bottom: 1px solid rgba(15, 23, 42, 0.06);
    font-weight: 600;
    color: var(--text-primary);
  }

  .mobile-links button:last-child,
  .mobile-links a:last-child {
    border-bottom: none;
  }

  .mobile-actions .cta-button {
    width: 100%;
  }

  .mobile-cart {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: rgba(0, 113, 227, 0.08);
    border-radius: 12px;
    font-weight: 600;
    color: var(--brand-primary);
  }

  .footer-grid {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 36px;
  }

  .footer-bottom-content {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 640px) {
  .announcement-content {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }


  .app-main {
    margin-top: 0;
  }

  .nav-content {
    padding: 14px 18px;
  }

  .logo img {
    height: 40px;
  }

  .footer-subscribe {
    flex-direction: column;
  }

  .footer-subscribe button {
    width: 100%;
  }

  .footer-links {
    flex-wrap: wrap;
  }
}
</style>
